<template>
    <modal class="diyDemandModel" :isShow="isShow" @keyup.esc="hide">
        <div class="header">自定义做法价格</div>
        <div class="modal-body" ref="recharRight">
            <div class="left-box">
                <div class="title">基本信息</div>
                <div class="tr-li">
                    <div class="lable-txt">做法名称：</div>
                    <div class="from-input">{{data?.name}}</div>
                </div>
                <div class="tr-li">
                    <div class="lable-txt">做法单价：</div>
                    <div class="from-input" style="width:115px">
                        <input-pattern class="key-focus" isFocSelect ref="price"
                            data-model='Eat_Price' pattern="number" :dplaces="2" v-model="Eat_Price" />
                    </div>
                    <div class="lable-txt">做法数量：</div>
                    <div class="from-input" style="width:115px">
                        <input-pattern class="key-focus" isFocSelect
                            data-model='Eat_Number' pattern="number" :dplaces="3" 
                            v-model="Eat_Number"/>
                    </div>
                </div>
            </div>
            <div class="right-box">
                <div class="keyboard">
                    <div class="key-li"><span data-value="7">7</span><span data-value="8">8</span><span
                            data-value="9">9</span></div>
                    <div class="key-li"><span data-value="4">4</span><span data-value="5">5</span><span
                            data-value="6">6</span></div>
                    <div class="key-li"><span data-value="1">1</span><span data-value="2">2</span><span
                            data-value="3">3</span></div>
                    <div class="key-li"><span data-value=".">.</span><span data-value="0">0</span><span
                            data-value="back"><i class="iconfont icon-zuojiantou"></i></span></div>
                </div>
            </div>
        </div>
        <div class="footer-box">
            <button class="btn btn-cancel" @click="hide()">取消</button>
            <button class="btn btn-confirm" @click="confirm()">确认</button>
        </div>
  </modal>
</template>

<script>
import {initKeyBoard} from '/src/common' 

export default {
    name:'diyDemandModel',
    emits:["change","close"],
    props:{
        isShow:Boolean,
        /*菜品信息*/
        data:{
            type:Object,
            default:null
        }
    },
    data(){
        return{
            Eat_Number:1,
            Eat_Price:""
        }
    },
    watch:{
        isShow(){
            if(this.isShow){
                this.init();
            }
        },
    },
    mounted(){
        this.$nextTick(()=> {
            initKeyBoard.call(this,this.$el,this.$refs.recharRight);
            this.init();
        })
    },
    methods:{
        hide(){
            this.$emit("close");
        },
        init(){
            this.Eat_Number=this.data?.Eat_Number||1;
            this.Eat_Price=this.data?.Eat_Price||"";

            this.$refs.price?.focus();
        },
        confirm(){
            if(!(this.Eat_Price>0)){
                this.$message.warning("请先输入价格");
                return;
            }
            if(!(this.Eat_Number>0)){
                this.$message.warning("请先输入数量");
                return;
            }
            this.$emit("change",{
                Eat_Number:this.Eat_Number,
                Eat_Price:this.Eat_Price
            });
        }
    }
}
</script>

<style lang="scss">
@import './diyDemandModel.scss';
</style>